/**
 * Formato legible del tiempo restante de sesión.
 *
 * Antes se mostraba como `minutos:segundos` (p. ej. `474:56`), poco claro.
 * Ahora se desglosa en horas / minutos / segundos.
 */

const parts = (totalSeconds: number) => {
  const s = Math.max(0, Math.floor(totalSeconds));
  return {
    h: Math.floor(s / 3600),
    m: Math.floor((s % 3600) / 60),
    s: s % 60,
  };
};

const pad = (n: number) => n.toString().padStart(2, '0');

/** Roomy, para el modal: "7 h 54 min", "12 min 30 s", "45 s". */
export const formatSessionTime = (totalSeconds: number): string => {
  const { h, m, s } = parts(totalSeconds);
  if (h > 0) return `${h} h ${pad(m)} min`;
  if (m > 0) return `${m} min ${pad(s)} s`;
  return `${s} s`;
};

/** Compacto, para la píldora del header: "7h 54m", "12m 30s", "45s". */
export const formatSessionTimeCompact = (totalSeconds: number): string => {
  const { h, m, s } = parts(totalSeconds);
  if (h > 0) return `${h}h ${pad(m)}m`;
  if (m > 0) return `${m}m ${pad(s)}s`;
  return `${s}s`;
};
